import { MAINNET_RELAY_API } from '@reservoir0x/relay-sdk'

export interface RelayTokenInfo {
  chainId: number
  address: string
  symbol: string
  name: string
  decimals: number
  vmType: string
  metadata: {
    logoURI: string
    verified: boolean
    isNative: boolean
  }
}

export async function getRelayAssetInfo({
  chainId,
  address,
}: {
  chainId: string
  address: string
}): Promise<RelayTokenInfo> {
  const url = `${MAINNET_RELAY_API}/currencies/v2`
  const body = {
    chainIds: [chainId],
    address,
  }
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
  if (!response.ok) {
    throw Error(response.statusText)
  }

  const data = await response.json()
  return data?.[0] as RelayTokenInfo
}
